import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

export const UploadFile = (payload: any) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.ResultFileUploadFile.UploadFile}`,
    payload
  );
};

export const GetAllFiles = (payload: any) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.ResultFileUploadFile.GetAllFiles}`,
    payload
  );
};

export const ArchiveFile = (payload: any) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.ResultFileUploadFile.Archive}`,
    payload
  );
};

export const GetFileTypes = (id: number) => {
  return HttpClient().get(
    `/${apiRoutes.PGXLis.ResultFileUploadFile.GetFileTypes}?reqTypeId=${id}`
  );
};

export const GetFileExpandData = (id: number) => {
  return HttpClient().get(
    `/${apiRoutes.PGXLis.ResultFileUploadFile.GetFileExpandData}?FileId=${id}`
  );
};

export const DownloadTemplate = (tempId: number) => {
  return HttpClient().get(
    `/${apiRoutes.PGXLis.ResultFileUploadFile.DownloadTemplate}/${tempId}`
  );
};

export const SendFile = (tempId: number, fileId: number) => {
  return HttpClient().get(
    `/${apiRoutes.PGXLis.ResultFileUploadFile.SendFile}/${tempId}/${fileId}`
  );
};

export const DeleteFileExpandData = (id: number) => {
  return HttpClient().delete(
    `/${apiRoutes.PGXLis.ResultFileUploadFile.DeleteFileExpandData}/${id}`
  );
};

export const DownloadFileWithData = (tempId: number, fileId: number) => {
  return HttpClient().get(
    `/${apiRoutes.PGXLis.ResultFileUploadFile.DownloadFileWithData}/${tempId}/${fileId}`
  );
};
